import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";

import { FlexLayoutModule } from "@angular/flex-layout";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from "@angular/material/tabs";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { AlertDialogComponent } from "./alert-dialog/alert-dialog.component";
import { PasswordDialogComponent } from "./password-dialog/password-dialog.component";
import { AboutDialogComponent } from "./about-dialog/about-dialog.component";
import { DescriptionLocaleFormDialogComponent } from "./description-locale-form-dialog/description-locale-form-dialog.component";
import { ReceiptDialogComponent } from "./receipt-dialog/receipt-dialog.component";
import { EditCustomerDetailsComponent } from "./edit-customer-details-dialog/edit-customer-details-dialog.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";
import { MatCardModule } from "@angular/material/card";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { DateTimeModule } from "../date-time/date-time.module";
import { SearchCustomerDialogComponent } from './search-customer-dialog/search-customer-dialog.component';
import { CustomTableModule } from "../custom-table/custom-table.module";
import { SearchSiteDialogComponent } from './search-site-dialog/search-site-dialog.component';
import { MatTooltipModule } from "@angular/material/tooltip";
import { SearchSupplierDialogComponent } from './search-supplier-dialog/search-supplier-dialog.component';
import { ChangeMopComponent } from "./change-mop-dialog/change-mop-dialog.component";
import { ManageFilesDialogComponent } from "./manage-files-dialog/manage-files-dialog.component";
import { SearchFilterModule } from "../search-filter/search-filter.module";
import { SelectProductsDialogComponent } from "./select-products-dialog/select-products-dialog.component";
import { ManageFileItemComponent } from "./manage-files-dialog/manage-file-item/manage-file-item.component";
import { ManageFilePreviewDialogComponent } from "./manage-files-dialog/manage-file-preview-dialog/manage-file-preview-dialog.component";
import { ApplyDiscountDialogComponent } from "./apply-discount-dialog/apply-discount-dialog.component";
import { SelectSequenceDialogComponent } from "./select-sequence-dialog/select-sequence-dialog.component";
import { SelectPlaylistDialogComponent } from './select-playlist-dialog/select-playlist-dialog.component';
import { EditRowDataDialogComponent } from "./edit-row-data-dialog/edit-row-data-dialog.component";
import { SelectGuideDialogComponent } from './select-guide-dialog/select-guide-dialog.component';
import { SelectSitesDialogComponent } from './select-sites-dialog/select-sites-dialog.component';
import { SelectSiteGroupsDialogComponent } from './select-site-groups-dialog/select-site-groups-dialog.component';
import { OverlayModule } from "@angular/cdk/overlay";
import { AdditionalDataDescriptionDialogComponent } from "./additional-data-dialog/additional-data-description-dialog.component";
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MatDialogModule,
    MatProgressBarModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatCardModule,
    MatListModule,
    MatSelectModule,
    DateTimeModule,
    CustomTableModule,
    MatTooltipModule,
    SearchFilterModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatSidenavModule,
    MatSlideToggleModule,
    RouterModule,
    OverlayModule
],
  exports: [
    ConfirmationDialogComponent,
    AlertDialogComponent,
    PasswordDialogComponent,
    AboutDialogComponent,
    DescriptionLocaleFormDialogComponent,
    ManageFilesDialogComponent,
    SelectProductsDialogComponent,
    ManageFileItemComponent, 
    ManageFilePreviewDialogComponent,
    ApplyDiscountDialogComponent,
    SelectSequenceDialogComponent,
    SelectPlaylistDialogComponent,
    EditRowDataDialogComponent,
    SelectGuideDialogComponent
  ],
  declarations: [
    ConfirmationDialogComponent,
    AlertDialogComponent,
    PasswordDialogComponent,
    AboutDialogComponent,
    DescriptionLocaleFormDialogComponent,
    ReceiptDialogComponent,
    EditCustomerDetailsComponent,
    SearchCustomerDialogComponent,
    SearchSiteDialogComponent,
    SearchSupplierDialogComponent,
    ChangeMopComponent,
    ManageFilesDialogComponent,
    SelectProductsDialogComponent,
    ManageFileItemComponent,
    ManageFilePreviewDialogComponent,
    ApplyDiscountDialogComponent,
    SelectSequenceDialogComponent,
    SelectPlaylistDialogComponent,
    EditRowDataDialogComponent,
    SelectGuideDialogComponent,
    SelectSitesDialogComponent,
    SelectSiteGroupsDialogComponent,
    AdditionalDataDescriptionDialogComponent
  ],
})
export class DialogModule {}
